import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import router from "./router";
import VueMeta from "vue-meta";
import VueSilentbox from "vue-silentbox";
import BackToTop from "vue-backtotop";
import { store } from "./store";
import Swal from "sweetalert2";
import AOS from "aos";
import "aos/dist/aos.css";
Vue.prototype.$Swal = Swal;
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 1000,
});
Vue.prototype.$Toast = Toast;
Vue.use(VueSilentbox);
Vue.use(BootstrapVue);
Vue.use(BackToTop);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "../src/assets/css/font-awesome.min.css";
import "../src/assets/css/material-design-iconic-font.min.css";
import "../src/assets/css/ionicons.min.css";
import "../src/assets/css/flaticon.min.css";
import "swiper/css/swiper.min.css";
import "../src/assets/css/animate.min.css";
import "../src/assets/scss/style.scss";

Vue.config.productionTip = false;
// console.log(router)
new Vue({
  router,
  store,
  mounted() {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount("#app");
